import {CopilotIcon, PaperAirplaneIcon} from '@primer/octicons-react'
import {Button, Stack} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import {useEffect, useRef} from 'react'

import styles from './AskCopilotNoReadmeCard.module.css'
import {sendSuggestionsShown, useAskCopilotPrompts} from './use-ask-copilot-prompts'

const ASK_COPILOT_LOCATION = 'no-readme-card'

/**
 * Blankslate card shown in the repo overview when no README is present.
 * Invites users to ask Copilot about the repository instead.
 */
export function AskCopilotNoReadmeCard() {
  const suggestionsShownRef = useRef(false)
  const {prompts, onPromptClick} = useAskCopilotPrompts({location: ASK_COPILOT_LOCATION, readme: false})

  useEffect(() => {
    if (suggestionsShownRef.current) return
    suggestionsShownRef.current = true

    sendSuggestionsShown(ASK_COPILOT_LOCATION)
  }, [])

  return (
    <Blankslate>
      <Blankslate.Visual>
        <CopilotIcon size={36} />
      </Blankslate.Visual>
      <Blankslate.Heading>Ask Copilot about this repository</Blankslate.Heading>
      <Blankslate.Description>
        This repository doesn&apos;t have a README yet. Ask Copilot to learn how this project works.
      </Blankslate.Description>
      <Stack direction="horizontal" gap="condensed" wrap="wrap" justify="center" className={styles.PromptActions}>
        {prompts.map(prompt => (
          <Button
            key={prompt.label}
            variant="default"
            leadingVisual={PaperAirplaneIcon}
            onClick={() => onPromptClick(prompt)}
          >
            {prompt.label}
          </Button>
        ))}
      </Stack>
    </Blankslate>
  )
}
